import Image from 'next/image';
import type { JSX } from 'react';
import type { IntlShape } from 'react-intl';
import Typography from '@alltrails/core/components/Typography';
import leaveNoTraceSrc from './leave-no-trace.svg';
import onePercentForThePlanetSrc from './one-percent-for-the-planet.svg';
import styles from './styles.module.scss';

type Props = {
  intl: IntlShape;
};

const MembersForThePlanet = ({ intl }: Props): JSX.Element => (
  <div className={styles.container}>
    <Typography className={styles.title} component="h2" mt="0" variant="text300bold" color="inverse">
      {intl.formatMessage({ defaultMessage: 'Members for the planet' })}
    </Typography>
    <div className={styles.membersIconsContainer}>
      <Image
        alt="1% for the Planet"
        className={styles.logo}
        height={36}
        src={onePercentForThePlanetSrc}
        width={86}
      />
      <Image alt="Leave No Trace" className={styles.logo} height={36} src={leaveNoTraceSrc} width={76} />
    </div>
  </div>
);

export default MembersForThePlanet;
